var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row", class: { "no_result-new": _vm.view == "purple" } },
      [
        _vm.view == "purple"
          ? [
              _c("div", { staticClass: "col-12 col-sm-8 col-lg-6 m-auto" }, [
                _c("div", { staticClass: "main_container" }, [
                  _c("div", { staticClass: "no_results__main_container" }, [
                    _c(
                      "div",
                      { staticClass: "no_results__main_container__title" },
                      [
                        _c("div", { staticClass: "title_text" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm._f("trans")(
                                  "st_public.sorry_we_couldnt_find"
                                )
                              ) +
                              "\n                  "
                          ),
                          _c("strong", { staticClass: "searchText" }, [
                            _vm._v(_vm._s(_vm.searchText))
                          ])
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "no_results__main_container__suggestions"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "no_results__main_container__suggestions__hint"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.Lets_try_one_more_time_with_tips"
                                  )
                                )
                              )
                            ])
                          ]
                        ),
                        _c(
                          "ul",
                          { staticClass: "no_results__main_container__list" },
                          [
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.Double_check_the_spelling"
                                  )
                                )
                              )
                            ]),
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.Search_with_just_phone_number"
                                  )
                                )
                              )
                            ]),
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.Find_someone_close_to_them"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "search_again_container search_again__main_container"
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errorMessage,
                                  expression: "errorMessage"
                                }
                              ],
                              staticClass:
                                "mt-1 rounded pt-1 error_message__new",
                              staticStyle: {
                                "background-color": "rgb(71 66 149)",
                                "margin-bottom": "10px",
                                color: "#fff",
                                "font-weight": "bold"
                              },
                              attrs: { id: "error_message" }
                            },
                            [
                              _c("span", {
                                staticClass: "fa fa-exclamation-triangle"
                              }),
                              _vm._v(" " + _vm._s(_vm.errorMessage))
                            ]
                          ),
                          _c(
                            "form",
                            {
                              staticClass: "advanced_filters_controller__new",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.search($event)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "advanced_filters_container" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "advanced_filters" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "advanced_filters_form"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "float_input_set float_base_8_4_12"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "label_input_set unstyled"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "unstyled "
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("trans")(
                                                            "st_public.first_name"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    staticClass:
                                                      "unstyled valid ",
                                                    attrs: {
                                                      id: "first_name",
                                                      name: "first_name",
                                                      placeholder: _vm._f(
                                                        "trans"
                                                      )("st_public.e_g_john"),
                                                      type: "text",
                                                      autocomplete: "on"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "label_input_set unstyled"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "unstyled "
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("trans")(
                                                            "st_public.middle_name"
                                                          )
                                                        ) + " "
                                                      )
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    staticClass:
                                                      "unstyled valid ",
                                                    attrs: {
                                                      id: "middle_name",
                                                      name: "middle_name",
                                                      placeholder: _vm._f(
                                                        "trans"
                                                      )("st_public.e_g_tom"),
                                                      type: "text",
                                                      autocomplete: "on",
                                                      value: ""
                                                    }
                                                  })
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "label_input_set unstyled"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "unstyled "
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("trans")(
                                                            "st_public.lasst_name"
                                                          )
                                                        ) + " "
                                                      )
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    staticClass:
                                                      "unstyled valid ",
                                                    attrs: {
                                                      id: "last_name",
                                                      name: "last_name",
                                                      placeholder: _vm._f(
                                                        "trans"
                                                      )("st_public.e_g_smith"),
                                                      type: "text",
                                                      autocomplete: "on"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "float_input_set float_base_6_6"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "label_input_set unstyled"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "unstyled "
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("trans")(
                                                            "st_public.phone_number"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    staticClass:
                                                      "unstyled valid ",
                                                    attrs: {
                                                      id: "phone",
                                                      name: "phone",
                                                      placeholder: _vm._f(
                                                        "trans"
                                                      )(
                                                        "st_public.e_g_555_55555"
                                                      ),
                                                      type: "tel",
                                                      autocomplete: "on",
                                                      value: ""
                                                    }
                                                  })
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "label_input_set unstyled"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "unstyled "
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("trans")(
                                                            "st_public.email_address"
                                                          )
                                                        ) + " "
                                                      )
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    staticClass:
                                                      "unstyled valid ",
                                                    attrs: {
                                                      id: "email",
                                                      name: "email",
                                                      placeholder: _vm._f(
                                                        "trans"
                                                      )(
                                                        "st_public.emailAtexample"
                                                      ),
                                                      type: "email",
                                                      autocomplete: "on",
                                                      value: ""
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "filters_modal_form_buttons"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "button no_results unstyled false",
                                                  attrs: { type: "submit" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("trans")(
                                                        "st_public.search"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "also_search_container__new" }, [
                    _c("div", { staticClass: "also_search_text" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("trans")(
                              "st_public.You Can Also Search For These People"
                            )
                          ) +
                          "\n              "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "search_suggestions float_base_4_4_4" },
                      [
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container__new" },
                          [
                            _c("div", {
                              staticClass: "fa fa-home suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")("st_public.New Neighbors")
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container__new" },
                          [
                            _c("div", {
                              staticClass: "fa fa-heart suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Potential Dates or Online Love Interests"
                                      )
                                    ) +
                                    "\n\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container__new" },
                          [
                            _c("div", {
                              staticClass:
                                "fa fa-exclamation-triangle suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Suspected Scammers"
                                      )
                                    ) +
                                    "\n\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container__new" },
                          [
                            _c("div", {
                              staticClass: "fa fa-briefcase suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Colleague and Business Associates"
                                      )
                                    ) +
                                    "\n\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container__new" },
                          [
                            _c("div", {
                              staticClass: "fa fa-users suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Friends, Enemies, and especially Frenemies"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container__new" },
                          [
                            _c("div", {
                              staticClass: "fa fa-question suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Yourself_Arent_You_Curious"
                                      )
                                    ) +
                                    "\n\n                  "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]
          : [
              _c("div", { staticClass: "col-12 col-sm-8 col-lg-6 m-auto" }, [
                _c("div", { staticClass: "main_container" }, [
                  _c("div", { staticClass: "no_results_container" }, [
                    _c("div", { staticClass: "no_results_title" }, [
                      _vm._m(0),
                      _c("div", { staticClass: "title_text" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm._f("trans")("st_public.sorry_we_couldnt_find")
                            ) +
                            "\n                  "
                        ),
                        _c("strong", { staticClass: "searchText" }, [
                          _vm._v(_vm._s(_vm.searchText))
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "no_results_suggestions" }, [
                      _c("div", { staticClass: "suggestions_hint" }, [
                        _c("i", { staticClass: "fa fa-lightbulb" }),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("trans")(
                                "st_public.Lets_try_one_more_time_with_tips"
                              )
                            )
                          )
                        ])
                      ]),
                      _c("ul", { staticClass: "no_results_list" }, [
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm._f("trans")(
                                "st_public.Double_check_the_spelling"
                              )
                            )
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm._f("trans")(
                                "st_public.Search_with_just_phone_number"
                              )
                            )
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm._f("trans")(
                                "st_public.Find_someone_close_to_them"
                              )
                            )
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "search_again_container" }, [
                      _c("div", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errorMessage,
                                expression: "errorMessage"
                              }
                            ],
                            staticClass: "mt-1 rounded pt-1",
                            staticStyle: {
                              "background-color": "#f00",
                              color: "#fff",
                              "font-weight": "bold"
                            },
                            attrs: { id: "error_message" }
                          },
                          [
                            _c("span", {
                              staticClass: "fa fa-exclamation-triangle"
                            }),
                            _vm._v(" " + _vm._s(_vm.errorMessage))
                          ]
                        ),
                        _c(
                          "form",
                          {
                            staticClass: "advanced_filters_controller",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.search($event)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "advanced_filters_container monolithic_advanced_filters_container"
                              },
                              [
                                _c("div", { staticClass: "advanced_filters" }, [
                                  _c(
                                    "div",
                                    { staticClass: "advanced_filters_form" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "float_input_set float_base_8_4_12"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "label_input_set unstyled"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "unstyled " },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("trans")(
                                                        "st_public.first_name"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("input", {
                                                staticClass: "unstyled valid ",
                                                attrs: {
                                                  id: "first_name",
                                                  name: "first_name",
                                                  placeholder: _vm._f("trans")(
                                                    "st_public.e_g_john"
                                                  ),
                                                  type: "text",
                                                  autocomplete: "on"
                                                }
                                              })
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "label_input_set unstyled"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "unstyled " },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("trans")(
                                                        "st_public.middle_name"
                                                      )
                                                    ) + " "
                                                  )
                                                ]
                                              ),
                                              _c("input", {
                                                staticClass: "unstyled valid ",
                                                attrs: {
                                                  id: "middle_name",
                                                  name: "middle_name",
                                                  placeholder: _vm._f("trans")(
                                                    "st_public.e_g_tom"
                                                  ),
                                                  type: "text",
                                                  autocomplete: "on",
                                                  value: ""
                                                }
                                              })
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "label_input_set unstyled"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "unstyled " },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("trans")(
                                                        "st_public.lasst_name"
                                                      )
                                                    ) + " "
                                                  )
                                                ]
                                              ),
                                              _c("input", {
                                                staticClass: "unstyled valid ",
                                                attrs: {
                                                  id: "last_name",
                                                  name: "last_name",
                                                  placeholder: _vm._f("trans")(
                                                    "st_public.e_g_smith"
                                                  ),
                                                  type: "text",
                                                  autocomplete: "on"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "float_input_set float_base_6_6"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "label_input_set unstyled"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "unstyled " },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("trans")(
                                                        "st_public.phone_number"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("input", {
                                                staticClass: "unstyled valid ",
                                                attrs: {
                                                  id: "phone",
                                                  name: "phone",
                                                  placeholder: _vm._f("trans")(
                                                    "st_public.e_g_555_55555"
                                                  ),
                                                  type: "tel",
                                                  autocomplete: "on",
                                                  value: ""
                                                }
                                              })
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "label_input_set unstyled"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "unstyled " },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("trans")(
                                                        "st_public.email_address"
                                                      )
                                                    ) + " "
                                                  )
                                                ]
                                              ),
                                              _c("input", {
                                                staticClass: "unstyled valid ",
                                                attrs: {
                                                  id: "email",
                                                  name: "email",
                                                  placeholder: _vm._f("trans")(
                                                    "st_public.emailAtexample"
                                                  ),
                                                  type: "email",
                                                  autocomplete: "on",
                                                  value: ""
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "filters_modal_form_buttons"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "button green_button no_results unstyled false",
                                              attrs: { type: "submit" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("trans")(
                                                    "st_public.search"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "also_search_container" }, [
                    _c("div", { staticClass: "also_search_text" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("trans")(
                              "st_public.You Can Also Search For These People"
                            )
                          ) +
                          "\n              "
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "search_suggestions float_base_4_4_4" },
                      [
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container" },
                          [
                            _c("div", {
                              staticClass: "fa fa-home suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")("st_public.New Neighbors")
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container" },
                          [
                            _c("div", {
                              staticClass: "fa fa-heart suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Potential Dates or Online Love Interests"
                                      )
                                    ) +
                                    "\n\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container" },
                          [
                            _c("div", {
                              staticClass:
                                "fa fa-exclamation-triangle suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Suspected Scammers"
                                      )
                                    ) +
                                    "\n\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container" },
                          [
                            _c("div", {
                              staticClass: "fa fa-briefcase suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Colleague and Business Associates"
                                      )
                                    ) +
                                    "\n\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container" },
                          [
                            _c("div", {
                              staticClass: "fa fa-users suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Friends, Enemies, and especially Frenemies"
                                      )
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "search_suggestion_container" },
                          [
                            _c("div", {
                              staticClass: "fa fa-question suggestion_icon"
                            }),
                            _c(
                              "div",
                              { staticClass: "search_suggestion_text" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "st_public.Yourself_Arent_You_Curious"
                                      )
                                    ) +
                                    "\n\n                  "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]
      ],
      2
    ),
    _vm.loading ? _c("div", { staticClass: "loading-page" }) : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no_results_title_circle" }, [
      _c("div", { staticClass: "circle" }, [
        _c("div", { staticClass: "icon-info" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fb20bfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb20bfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/no-result/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2fb20bfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/no-result/index.vue
// module chunks = 23